module.exports = __webpack_public_path__ + "static/popup_bg-12bc186db82da09db665281adbad9572.png";